import React from "react";

export default function PrivacyPolicy() {
  return (
    <section className="page-container">
      <h2>Privacy Policy</h2>

      <p>This Privacy Policy governs how Berkinson ("we", "us", "our") collects,
      uses, maintains and discloses information collected from users ("you",
      "your"). This applies to the website and services provided.</p>

      <h3>Information Collection</h3>
      <p>We collect personal information you voluntarily provide (such as name,
      email, phone, address) when you submit a booking form or contact form.</p>

      <h3>Use of Information</h3>
      <p>Collected data is used to process your booking, respond to inquiries,
      and provide requested services. We may send transactional emails (booking
      confirmation, updates).</p>

      <h3>Data Sharing</h3>
      <p>We do not sell, rent, or share your personal information with
      third‑parties except where necessary to fulfill services (e.g., delivery
      partners) or where required by law.</p>

      <h3>Cookies & Tracking</h3>
      <p>We use cookies and similar technologies to improve user experience
      and analyze site traffic. You can manage cookie permissions via your browser
      settings.</p>

      <h3>Data Retention</h3>
      <p>We retain personal data as needed to provide services and comply with
      legal obligations.</p>

      <h3>Your Rights</h3>
      <p>You have the right to access, update, or request deletion of your information.
      Contact us at <a href="mailto:support@berkinson.com">support@berkinson.com</a>.</p>

      <p>Last updated: November 2025</p>
    </section>
  );
}
